import axios from 'axios';

import qs from 'qs';

import { get, set, isObject, isArray } from 'lodash';

class Api {
  constructor() {
    this.options = {
      ext: '.json'
    };

    this.instance = null;
    this.endpoint = process.env.REACT_APP_API_URL;
  }

  createInstance = () => {
    return this;
  };

  getInstance() {
    if (!this.instance) {
      this.instance = this.createInstance();
    }

    return this.instance;
  }

  setOptions(options = {}) {
    this.options = options;
  }

  get(url = '', options = {}) {
    return this.request(
      url,
      Object.assign({}, options, {
        method: 'get'
      })
    );
  }

  post(url = '', options = {}) {
    return this.request(
      url,
      Object.assign({}, options, {
        method: 'post'
      })
    );
  }

  put(url = '', options = {}) {
    return this.request(
      url,
      Object.assign({}, options, {
        method: 'put'
      })
    );
  }

  delete(url = '', options = {}) {
    return this.request(
      url,
      Object.assign({}, options, {
        method: 'delete'
      })
    );
  }

  request(url = '', options = {}) {
    let requestUrl = `${this.endpoint}/${url}`;
    const questionPos = requestUrl.indexOf('?');

    if (questionPos > -1) {
      requestUrl =
        requestUrl.slice(0, questionPos) +
        this.options.ext +
        requestUrl.slice(questionPos);
    } else {
      requestUrl += this.options.ext;
    }

    let headers = {};

    let token = localStorage.getItem('token');

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    let requestOptions = Object.assign({}, options);

    delete requestOptions.method;

    if (options.method === 'get') {
      if (requestOptions.params) {
        requestUrl +=
          (requestUrl.indexOf('?') > 1 ? '&' : '?') +
          qs.stringify(requestOptions.params);

        delete requestOptions.params;
      }

      return axios.get(
        requestUrl,
        Object.assign({}, requestOptions, {
          headers: headers
        })
      );
    }

    if (options.method === 'delete') {
      return axios.delete(
        requestUrl,
        Object.assign({}, requestOptions, {
          headers: headers
        })
      );
    }

    if (requestOptions.files) {
      const submitRequest = async function(resolve, reject) {
        try {
          const response = await axios[options.method](
            requestUrl,
            requestOptions,
            {
              headers: headers
            }
          );
          resolve(response);
        } catch (ex) {
          reject(ex);
        }
      };

      return new Promise((resolve, reject) => {
        let file;
        let reader = new FileReader();
        let paths = requestOptions.files || [];
        if (paths && !isArray(paths)) {
          paths = [paths];
        }

        delete requestOptions.files;

        if (paths.length === 0) {
          return submitRequest(resolve, reject);
        }

        let loaded = 0;

        paths.forEach(path => {
          file = get(requestOptions, path);
          if (file && isObject(file)) {
            reader.onload = loadedFile => {
              loaded++;

              requestOptions = set(
                requestOptions,
                path,
                loadedFile.target.result
              );

              if (loaded === paths.length) {
                submitRequest(resolve, reject);
              }
            };

            reader.readAsDataURL(file);
          } else {
            loaded++;

            if (loaded === paths.length) {
              submitRequest(resolve, reject);
            }
          }
        });
      });
    }

    return axios[options.method](requestUrl, requestOptions, {
      headers: headers
    });
  }
}

export default new Api();



// WEBPACK FOOTER //
// ./src/lib/api.js